import type { BffApiClient } from "@/app/api-client"

export function getBlockchainsQueryParams(apiClient: BffApiClient) {
  return {
    queryKey: ["blockchains"],
    queryFn: async () => {
      const response = await apiClient.api.blockchains.all.$get(undefined, {
        init: {
          next: {
            // Cache blockchains response on next server for 2 minutes
            revalidate: 120,
          },
        },
      })

      if (!response.ok) throw await response.json()

      const result = response.json()

      return result
    },
  }
}
